// @flow
import cn from 'classnames';
import {CustomScrollbars} from 'modules/common/components/CustomScrollBar';
import {formatDate} from 'modules/common/helpers/date';
import {ReactComponent as CloseIcon} from 'modules/common/icons/cross.svg';
import type {TNotification} from 'modules/common/types';
import React, {memo, useCallback, useRef} from 'react';
import {useIntl} from 'react-intl';
import {useClickAway} from 'react-use';
import styles from './styles.local.less';

const Notification = memo<TNotification>(({date, isNew, text}: TNotification) => {
    return (
        <div className={styles.notification}>
            <div className={styles.notificationDate}>{formatDate({date, formatType: "dd.MM.yyyy' 'HH:mm"})}</div>
            <div className={cn({[styles.newNotification]: isNew})}>{text}</div>
        </div>
    );
});
Notification.displayName = 'notification';
type TProps = {
    isOpen: boolean,
    notificationList: Array<TNotification>,
    onClose: () => void,
};
/**
 * Компонент с уведомлениями при клике на колокольчик в шапке
 * @param {*} props Параметры
 * @returns {*} React-компонент
 */
export const HeaderNotificationContainer = ({isOpen, notificationList, onClose}: TProps) => {
    const intl = useIntl();
    const containerRef = useRef(null);
    const handleClose = useCallback(() => {
        if (isOpen) {
            onClose();
        }
    }, [isOpen, onClose]);

    useClickAway(containerRef, handleClose);

    return (
        <div className={cn(styles.containerWrapper, {[styles.openedContainer]: isOpen})} ref={containerRef}>
            <div className={styles.head}>
                <h2 className="f-w_bold">{intl.formatMessage({defaultMessage: 'Уведомления', id: 'common.headerNotificationContainer.title'})}</h2>
                <CloseIcon className={styles.closeIcon} onClick={onClose} />
            </div>
            <div className="d_f f-d_c a-i_center h_full ov_a">
                <CustomScrollbars>
                    {' '}
                    {notificationList.length ? (
                        notificationList.map((notification) => <Notification {...notification} key={notification.id} />)
                    ) : (
                        <h3 className={styles.emptyBlock}>
                            {intl.formatMessage({defaultMessage: 'У вас еще нет уведомлений', id: 'common.headerNotificationContainer.emptyText'})}
                        </h3>
                    )}
                </CustomScrollbars>
            </div>
        </div>
    );
};
